{
  "back": "ਵਾਪਸ",
  "form": "ਫਾਰਮ",
  "purposeTitle": "ਤੁਹਾਡੇ ਸਟਾਪ ਦਾ ਮਕਸਦ ਕੀ ਹੈ?",
  "appointmentInfoTitle": "ਮੁਲਾਕਾਤ ਦੀ ਜਾਣਕਾਰੀ",
  "appointmentInfoHint": "ਜੇ ਤੁਹਾਡੀ ਮੁਲਾਕਾਤ ਹੈ ਤਾਂ ਇਹ ਖੇਤਰ ਜ਼ਰੂਰ ਭਰੋ।",
  "checkInDetailsTitle": "ਚੈੱਕ-ਇਨ ਵੇਰਵੇ",
  "checkInDetailsHint": "ਤੁਹਾਡੀ ਫੇਰੀ ਬਾਰੇ ਵਾਧੂ ਜਾਣਕਾਰੀ।",
  "driverPhoneLabel": "ਡਰਾਈਵਰ ਦਾ ਫ਼ੋਨ ਨੰਬਰ",
  "activateWhatsAppTitle": "ਵਟਸਐਪ ਮੈਸੇਜਿੰਗ ਚਾਲੂ ਕਰੋ",
  "activateWhatsAppBody": "ਗੁਦਾਮ ਨਾਲ ਗੱਲਬਾਤ ਕਰਨ ਲਈ, ਜਦੋਂ ਅਸੀਂ ਤੁਹਾਨੂੰ ਪਹਿਲਾ ਵਟਸਐਪ ਸੁਨੇਹਾ ਭੇਜੀਏ ਤਾਂ ਕਿਰਪਾ ਕਰਕੇ \"OK\" ਲਿਖ ਕੇ ਜਵਾਬ ਦਿਓ।",
  "whatsappDelayBanner": "ਪਹਿਲਾ ਵਟਸਐਪ ਸੁਨੇਹਾ ਪਹੁੰਚਣ ਵਿੱਚ ਇੱਕ ਮਿੰਟ ਤੱਕ ਦਾ ਸਮਾਂ ਲੱਗ ਸਕਦਾ ਹੈ।",
  "notesLabel": "ਨੋਟਸ",
  "notesPlaceholder": "ਕੀ ਸਹੂਲਤ ਲਈ ਕੋਈ ਖਾਸ ਹਦਾਇਤਾਂ ਜਾਂ ਨੋਟਸ ਹਨ?",
  "addNoteToWarehouse": "ਗੋਦਾਮ ਲਈ ਨੋਟ ਸ਼ਾਮਲ ਕਰੋ",
  "verifyAndCheckIn": "ਪੁਸ਼ਟੀ ਕਰੋ ਅਤੇ ਚੈੱਕ-ਇਨ ਕਰੋ",
  "completeCheckIn": "ਚੈੱਕ-ਇਨ ਪੂਰਾ ਕਰੋ",
  "visitGroupInbound": "ਇਨਬਾਊਂਡ",
  "visitGroupOutbound": "ਆਊਟਬਾਊਂਡ",
  "visitGroupBoth": "ਇਨਬਾਊਂਡ ਅਤੇ ਆਊਟਬਾਊਂਡ",
  "visitUnloadTruck": "ਮੇਰਾ ਟਰੱਕ ਖਾਲੀ ਕਰੋ",
  "visitDropTrailer": "ਮੇਰਾ ਟ੍ਰੇਲਰ ਜਾਂ ਕੰਟੇਨਰ ਛੱਡੋ",
  "visitLoadTruck": "ਮੇਰਾ ਟਰੱਕ ਲੋਡ ਕਰੋ",
  "visitHookTrailer": "ਟ੍ਰੇਲਰ ਜਾਂ ਕੰਟੇਨਰ ਜੋੜੋ (ਹੁੱਕ ਕਰੋ)",
  "visitUnloadLoad": "ਮੇਰਾ ਟਰੱਕ ਖਾਲੀ ਅਤੇ ਲੋਡ ਕਰੋ",
  "visitDropHook": "ਟ੍ਰੇਲਰ ਜਾਂ ਕੰਟੇਨਰ ਛੱਡੋ ਅਤੇ ਜੋੜੋ",
  "containerTrailer": "ਟ੍ਰੇਲਰ",
  "containerContainer": "ਕੰਟੇਨਰ",
  "containerOversized": "ਓਵਰਸਾਈਜ਼ਡ",
  "containerOther": "ਹੋਰ",
  "defaultReferenceName": "PO ਨੰਬਰ",
  "identifierSuffix": "{reference} ਜਾਂ ਪੁਸ਼ਟੀ ਨੰਬਰ",
  "licenseOrDotRequired": "ਕਿਰਪਾ ਕਰਕੇ ਲਾਇਸੈਂਸ ਪਲੇਟ ਜਾਂ DOT ਨੰਬਰ ਭਰੋ",
  "appointmentNotFound": "ਅਸੀਂ ਤੁਹਾਡੀ ਮੁਲਾਕਾਤ ਲੱਭ ਨਹੀਂ ਸਕੇ",
  "referenceNotFound": "ਕੋਈ ਮਿਲਦੀ-ਜੁਲਦੀ ਮੁਲਾਕਾਤ ਨਹੀਂ ਮਿਲੀ। ਹਵਾਲਾ ਨੰਬਰ ਅੱਖਰਾਂ ਦੇ ਵੱਡੇ/ਛੋਟੇ ਰੂਪ ਪ੍ਰਤੀ ਸੰਵੇਦਨਸ਼ੀਲ ਹਨ।",
  "referenceCaseSensitiveHint": "ਹਵਾਲਾ ਨੰਬਰ ਅੱਖਰਾਂ ਦੇ ਵੱਡੇ/ਛੋਟੇ ਰੂਪ ਪ੍ਰਤੀ ਸੰਵੇਦਨਸ਼ੀਲ ਹੈ",
  "messaging": {
    "whatsappFailedTitle": "ਵਟਸਐਪ ਸੁਨੇਹਾ ਭੇਜਣ ਵਿੱਚ ਅਸਮਰੱਥ",
    "smsFailedTitle": "SMS ਸੁਨੇਹਾ ਭੇਜਣ ਵਿੱਚ ਅਸਮਰੱਥ",
    "whatsappFailedBody": "ਅਸੀਂ {displayPhone} ਨੂੰ ਸੁਨੇਹਾ ਨਹੀਂ ਭੇਜ ਸਕੇ। <br /><br /> ਜੇ ਤੁਸੀਂ ਪਹਿਲਾਂ ਸਬਸਕ੍ਰਿਪਸ਼ਨ ਰੱਦ ਕੀਤੀ ਸੀ, ਤਾਂ ਇਸ ਗੁਦਾਮ ਤੋਂ ਸੁਨੇਹੇ ਦੁਬਾਰਾ ਪ੍ਰਾਪਤ ਕਰਨ ਲਈ ਕਿਰਪਾ ਕਰਕੇ <a href='{waUrl}' target='_blank' rel=\"noopener noreferrer\">{senderPhone}</a> ਨੂੰ START ਲਿਖ ਕੇ ਭੇਜੋ।",
    "smsFailedBody": "ਅਸੀਂ {displayPhone} ਨੂੰ ਸੁਨੇਹਾ ਨਹੀਂ ਭੇਜ ਸਕੇ। <br /><br /> ਜੇ ਤੁਸੀਂ ਪਹਿਲਾਂ ਸਬਸਕ੍ਰਿਪਸ਼ਨ ਰੱਦ ਕੀਤੀ ਸੀ, ਤਾਂ ਇਸ ਗੁਦਾਮ ਤੋਂ SMS ਸੁਨੇਹੇ ਦੁਬਾਰਾ ਪ੍ਰਾਪਤ ਕਰਨ ਲਈ ਕਿਰਪਾ ਕਰਕੇ <a href='{smsUrl}'>{senderPhone}</a> ਨੂੰ START ਲਿਖ ਕੇ ਭੇਜੋ।",
    "fallbackPhone": "ਦਿੱਤਾ ਗਿਆ ਫ਼ੋਨ ਨੰਬਰ"
  }
}
